export default __webpack_public_path__ + "static/media/amex.6bb5ee9f.svg";